/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateAlertRequest { 
    id: string;
    accountId?: string | null;
    positiveFrequency: number;
    negativeFrequency: number;
    percentThreshold: number;
}

